import type * as FavCache from '@finn-no/favorite-api-browser-client';
import { useMemo, useState } from 'react';

type useSearchProps = {
    items: FavCache.FavoriteListType[];
};

const useSearch = ({ items }: useSearchProps) => {
    const [searchQuery, setSearchQuery] = useState('');

    const filteredFavoriteLists = useMemo(() => {
        const query = searchQuery.toLowerCase();
        return query
            ? items.filter((fl) => fl.name.toLowerCase().includes(query))
            : items;
    }, [items, searchQuery]);

    return { searchQuery, setSearchQuery, filteredFavoriteLists };
};

export default useSearch;
